export default __webpack_public_path__ + "static/accordion_big-ee69670a328477061154e45bc84233ce.png";